export default __webpack_public_path__ + "static/media/pnsv_stand_LaCorona.d126f407.png";